// extracted by mini-css-extract-plugin
export default {"root":"Separator_root__MJ6LM","horizontal":"Separator_horizontal__WO4Y+","vertical":"Separator_vertical__wSE7z"};